import React from 'react';
import { useMonth } from '@datepicker-react/hooks';
import Day from './Day';

type DayType = { date: Date; dayLabel: string };

function Month({ year, month, firstDayOfWeek }) {
  const { days, weekdayLabels, monthLabel } = useMonth({
    year,
    month,
    firstDayOfWeek,
  });
  return (
    <div>
      <div style={{ textAlign: 'center', margin: '0 0 16px' }}>
        <strong>{monthLabel}</strong>
      </div>
      <div className="flex font-bold font-display">
        {weekdayLabels.map((dayLabel) => (
          <div className="flex-1 text-center" key={dayLabel}>
            {dayLabel}
          </div>
        ))}
      </div>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(7, 1fr)',
          justifyContent: 'center',
        }}
      >
        {days.map((day: number | DayType, index) => {
          if (typeof day === 'number')
            return <div key={`month-spacer-${index}`}></div>;
          return (
            <Day
              date={day.date}
              key={monthLabel + day.dayLabel}
              day={day.dayLabel}
            />
          );
        })}
      </div>
    </div>
  );
}

export default React.memo(Month);
